(function () {
  var root = document.getElementById('find-my-piece');
  if (!root) return;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML.replace(/"/g, '&quot;');
  }

  function money(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  var dataEl = document.getElementById('FindMyPieceData');
  var products = [];
  try {
    products = JSON.parse(dataEl.textContent);
  } catch (e) {
    products = [];
  }

  // ---- questions -----------------------------------------------------------

  // Bands are by area and split the collection 9 / 8 / 9. They double as price
  // tiers because everything Small is a paper print and everything Large is a
  // canvas original -- which is why budget isn't a separate question.
  var SIZE_ANY = 'Not sure yet';
  var SIZES = [
    { label: 'Small', note: 'up to 16×20 in · from $25', max: 320 },
    { label: 'Medium', note: '19×21 to 24×30 in · from $150', max: 750 },
    { label: 'Large', note: '24×36 in and up · from $250', max: Infinity },
    { label: SIZE_ANY, any: true }
  ];

  var TONE_ANY = 'A mix / not sure';
  var TONES = ['Warm neutrals', 'Cool neutrals', 'Earthy & green', TONE_ANY];

  var MAX_RESULTS = 4;

  var state = { size: null, tone: null };

  var openBtn = document.getElementById('fmp-open');
  var closeBtn = document.getElementById('fmp-close');
  var panel = document.getElementById('fmp-panel');
  var thread = document.getElementById('fmp-body');

  var reduceMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- size helpers --------------------------------------------------------

  // "24x36" -> 864. Anything unparsable sorts last rather than breaking things.
  function areaOf(product) {
    var m = /^([\d.]+)\s*x\s*([\d.]+)/i.exec(product.size || '');
    return m ? parseFloat(m[1]) * parseFloat(m[2]) : null;
  }

  function bandIndexOf(product) {
    var area = areaOf(product);
    if (area == null) return null;
    for (var i = 0; i < SIZES.length; i++) {
      if (SIZES[i].any) continue;
      if (area <= SIZES[i].max) return i;
    }
    return null;
  }

  // ---- conversation plumbing ----------------------------------------------

  // Deliberately setTimeout, not requestAnimationFrame: rAF is suspended while
  // the tab is hidden, so a backgrounded chat would never scroll at all. The
  // delay still lets the just-appended node lay out, so scrollHeight is real.
  //
  // Smooth scrolling is likewise suspended when hidden, and consecutive smooth
  // scrolls can interrupt each other, so a short check afterwards snaps the
  // thread down if the animation didn't land.
  function scrollDown() {
    setTimeout(function () {
      var target = thread.scrollHeight;
      var animate = !reduceMotion && !document.hidden && thread.scrollTo;

      if (animate) {
        thread.scrollTo({ top: target, behavior: 'smooth' });
        setTimeout(function () {
          if (thread.scrollTop + thread.clientHeight < thread.scrollHeight - 4) {
            thread.scrollTop = thread.scrollHeight;
          }
        }, 420);
      } else {
        thread.scrollTop = target;
      }
    }, 0);
  }

  function append(node) {
    thread.appendChild(node);
    // Result images have no dimensions until they load, so the thread grows
    // after insertion. Scroll again once each one settles.
    node.querySelectorAll && node.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', scrollDown, { once: true });
    });
    scrollDown();
    return node;
  }

  function bubble(cls, html) {
    var el = document.createElement('div');
    el.className = 'fmp__msg fmp__msg--' + cls;
    el.innerHTML = html;
    return append(el);
  }

  function say(html) {
    return bubble('bot', html);
  }

  function said(text) {
    return bubble('user', escapeHtml(text));
  }

  // A brief "typing" pause is what makes this read as a conversation rather
  // than a form that redraws. Skipped entirely for reduced-motion users.
  function botSays(html, done) {
    if (reduceMotion) {
      say(html);
      if (done) done();
      return;
    }
    var dots = append(Object.assign(document.createElement('div'), {
      className: 'fmp__msg fmp__msg--bot fmp__typing',
      innerHTML: '<span></span><span></span><span></span>'
    }));
    setTimeout(function () {
      dots.remove();
      say(html);
      if (done) done();
    }, 450);
  }

  function choices(items, onPick) {
    var wrap = document.createElement('div');
    wrap.className = 'fmp__choices';
    items.forEach(function (item, i) {
      var label = typeof item === 'string' ? item : item.label;
      var note = typeof item === 'string' ? '' : item.note;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fmp__choice';
      btn.innerHTML = '<span class="fmp__choice-label">' + escapeHtml(label) + '</span>' +
        (note ? '<span class="fmp__choice-note">' + escapeHtml(note) + '</span>' : '');
      btn.addEventListener('click', function () {
        wrap.remove();          // a used quick-reply row shouldn't linger
        said(label);
        onPick(i);
      });
      wrap.appendChild(btn);
    });
    return append(wrap);
  }

  // ---- steps ---------------------------------------------------------------

  function start() {
    thread.innerHTML = '';
    state = { size: null, tone: null };
    say('Hi — I can help you find a piece for your space.');
    botSays('First, how much wall are you filling?', function () {
      choices(SIZES, function (i) {
        state.size = SIZES[i];
        askTone();
      });
    });
  }

  function askTone() {
    botSays('And what tones are the walls and furniture in that room?', function () {
      choices(TONES, function (i) {
        state.tone = TONES[i];
        showResults();
      });
    });
  }

  // ---- results -------------------------------------------------------------

  function rank() {
    var sizeMatters = !state.size.any;
    var toneMatters = state.tone !== TONE_ANY;
    var wantBand = SIZES.indexOf(state.size);

    return products
      .map(function (p, i) {
        var band = bandIndexOf(p);
        // Size is a distance, not yes/no: asked for Large, a Medium is a better
        // fallback than a Small.
        var sizeGap = 0;
        if (sizeMatters) {
          sizeGap = band == null ? SIZES.length : Math.abs(band - wantBand);
        }
        return {
          product: p,
          sizeGap: sizeGap,
          toneMiss: toneMatters && p.tone !== state.tone ? 1 : 0,
          order: i
        };
      })
      .sort(function (a, b) {
        // Size first: the wall is a hard constraint, tone is a preference.
        // Ties fall back to Julie's own ordering of the collection.
        return a.sizeGap - b.sizeGap || a.toneMiss - b.toneMiss || a.order - b.order;
      });
  }

  function showResults() {
    var ranked = rank();
    var filtering = !state.size.any || state.tone !== TONE_ANY;

    var exact = ranked.filter(function (r) {
      return r.sizeGap === 0 && r.toneMiss === 0;
    }).slice(0, MAX_RESULTS);

    var near = ranked.filter(function (r) {
      return r.sizeGap !== 0 || r.toneMiss !== 0;
    }).slice(0, MAX_RESULTS - exact.length);

    if (!exact.length && !near.length) {
      botSays('Nothing is available right now — do check back soon.', finish);
      return;
    }

    var lead;
    if (!filtering) {
      lead = 'Here are a few pieces to start with.';
    } else if (exact.length) {
      lead = exact.length === 1
        ? 'One piece fits exactly — here it is.'
        : 'Here’s what fits.';
    } else {
      lead = 'Nothing matches exactly, but these come closest.';
    }

    botSays(lead, function () {
      if (exact.length) append(cards(exact));
      if (near.length) {
        if (exact.length) say('A couple of others worth seeing:');
        append(cards(near));
      }
      finish();
    });
  }

  function finish() {
    var wrap = document.createElement('div');
    wrap.className = 'fmp__choices fmp__choices--end';
    var all = document.createElement('a');
    all.className = 'fmp__choice fmp__choice--link';
    all.href = '/collections/all-available-products';
    all.textContent = 'See all pieces';
    var again = document.createElement('button');
    again.type = 'button';
    again.className = 'fmp__choice';
    again.textContent = 'Start over';
    again.addEventListener('click', start);
    wrap.appendChild(all);
    wrap.appendChild(again);
    append(wrap);
  }

  function cards(list) {
    var wrap = document.createElement('div');
    wrap.className = 'fmp__results';
    wrap.innerHTML = list.map(function (r) {
      var p = r.product;
      var safeTitle = escapeHtml(p.title);
      var img = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + safeTitle + '">'
        : '<span class="fmp__result-noimg" aria-hidden="true"></span>';
      var size = p.size
        ? '<span class="fmp__result-size">' + escapeHtml(p.size.replace(/x/i, ' × ')) + ' in</span>'
        : '';
      return '<a class="fmp__result" href="' + escapeHtml(p.url) + '">' +
        img +
        '<span class="fmp__result-text">' +
          '<span class="fmp__result-title">' + safeTitle + '</span>' + size +
        '</span>' +
        '<span class="fmp__result-price">' + money(p.price) + '</span>' +
      '</a>';
    }).join('');
    return wrap;
  }

  // ---- open / close --------------------------------------------------------

  function openPanel() {
    panel.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    root.classList.add('fmp--open');
    if (!thread.children.length) start();
    scrollDown();
  }

  function closePanel() {
    panel.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    root.classList.remove('fmp--open');
  }

  openBtn.addEventListener('click', function () {
    if (panel.hidden) openPanel();
    else closePanel();
  });
  closeBtn.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closePanel();
  });
})();
